import { useState } from 'react';
import { AlertCircle, Mail, X } from 'lucide-react';
import { useAuthStore } from '@/stores/authStore';
import api from '@/lib/api';

export default function EmailVerificationBanner() {
  const { user } = useAuthStore();
  const [isResending, setIsResending] = useState(false);
  const [message, setMessage] = useState('');
  const [dismissed, setDismissed] = useState(false);

  // Don't show if email is already verified or banner was dismissed
  if (!user || user.email_verified_at || dismissed) {
    return null;
  }

  const handleResend = async () => {
    setIsResending(true);
    setMessage('');

    try {
      const response = await api.post('/email/resend');
      setMessage(response.data.message || 'Email enviado correctamente');
    } catch (error: unknown) {
      const err = error as { response?: { data?: { message?: string } } };
      setMessage(err.response?.data?.message || 'Error al enviar el email');
    } finally {
      setIsResending(false);
    }
  };

  return (
    <div className="bg-yellow-50 border-b border-yellow-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3">
        <div className="flex items-center justify-between gap-4">
          <div className="flex items-center gap-3 flex-1">
            <AlertCircle className="w-5 h-5 text-yellow-600 flex-shrink-0" />
            <div className="flex-1">
              <p className="text-sm text-yellow-800 font-medium">
                Verifica tu email para acceder a todas las funcionalidades
              </p>
              <p className="text-xs text-yellow-700 mt-0.5">
                Hemos enviado un email de verificación a <span className="font-semibold">{user.email}</span>
              </p>
              {message && (
                <p className="text-xs text-yellow-700 mt-1 font-medium">
                  {message}
                </p>
              )}
            </div>
          </div>

          <div className="flex items-center gap-2">
            <button
              onClick={handleResend}
              disabled={isResending}
              className="flex items-center gap-1.5 px-3 py-1.5 bg-yellow-100 hover:bg-yellow-200 text-yellow-800 text-sm font-medium rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <Mail className="w-4 h-4" />
              {isResending ? 'Enviando...' : 'Reenviar email'}
            </button>

            <button
              onClick={() => setDismissed(true)}
              className="p-1.5 text-yellow-600 hover:text-yellow-800 transition-colors"
              aria-label="Cerrar"
            >
              <X className="w-4 h-4" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
